<script setup lang="tsx">
import type { RiskConfig, VulnerabilityMeta } from '@/models/api-generated'
import CardRow from './CardRow.vue'
import RiskScoreBadge from '../RiskScoreBadge.vue'
import { truncate, averageResidual } from '@/services/utils'
import { h } from 'vue'
import RisksTooltip from '../RisksTooltip.vue'

const props = defineProps<{
	config?: RiskConfig
}>()
const model = defineModel<VulnerabilityMeta[]>({ required: true })

const emit = defineEmits<{
	(e: 'go-to-risks', riskNames: string[], treatments: string[]): void
}>()

function goToRisks(name: string[]) {
	if (!name.length) return
	emit('go-to-risks', name, [])
}
</script>

<template>
	<div class="rounded-container p-4 pe-4 overflow-auto text-nowrap">
		<p class="text-center fw-bold">
			{{ $t('risk.tabs.vulnerabilities') }}
		</p>

		<table class="w-100">
			<CardRow :underline="true">
				<template #col0>{{ $t('vulnerability.name') }}</template>
				<template #col1>{{ $t('risk.count') }}</template>
				<template #col_end> {{ $t('risk.residualRiskScore') }} </template>
			</CardRow>

			<CardRow v-for="a in model" :key="a.id">
				<template #col0>
					{{ a.vulnerability.code }}
					<span v-one-tooltip="a.vulnerability.name">{{ truncate(a.vulnerability.name, 10) }}</span>
				</template>
				<template #col1>
					<div
						class="text-center risks-cell"
						v-one-tooltip="{
							content: () => h(RisksTooltip, { risks: a.risks, config: props.config }),
						}"
						@click="goToRisks(a.risks.map((r) => r.name))"
					>
						{{ a.risks.length }}
					</div>
				</template>
				<template #col_end><RiskScoreBadge :model-value="averageResidual(a.risks)" :config="props.config" /></template>
			</CardRow>
		</table>
	</div>
</template>
